import { render } from "./ProjectInfo.vue?vue&type=template&id=231a8a58"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__